import { TypedUseSelectorHook, useSelector } from 'react-redux'

import { Action, configureStore } from '@reduxjs/toolkit'

import { ThunkAction } from 'redux-thunk'
import { questionReducer } from './services/slices/questionSlice'

export const store = configureStore({
  reducer: {
    questions: questionReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
